import * as Yup from 'yup';

export const RecordSchema = Yup.object()
                               .shape({
                                          productTitle: Yup.string()
                                                           .required('Required'),
                                      });
